import * as React from 'react';
import { Context } from 'react';

import { AttachmentItem, DeleteAttachmentRequest } from '../../Common/CommonModels/Attachments';
import { CDMRecord } from './CDMRecord';
import { DataOwnerRequestRecord } from './DataOwnerRequestRecord';
import { RuleSetRecord } from './RuleSetRecord';

export interface IDataOwnerRequestDetails {
  dataOwnerId: string;
  dataOwnerName?: string;
  request?: DataOwnerRequestRecord;
  cdms: CDMRecord[];
  ruleSets: RuleSetRecord[];

  nonProdApprovedCdms: CDMRecord[];
  prodApprovedCdms: CDMRecord[];

  nonProdApprovedRuleSets?: RuleSetRecord[];
  prodApprovedRuleSets?: RuleSetRecord[];

  cdmDeletionList: string[];
  ruleSetDeletionList: string[];

  savedCdmIdList: string[];
  savedRuleSetIdList: string[];

  attachmentList: AttachmentItem[];
  deleteAttachmentRequestList: DeleteAttachmentRequest[];

  addUpdateRequest(value: DataOwnerRequestRecord): void;
  addCdmList(value: CDMRecord): void;
  updateCdmList(key: number, value: CDMRecord): void;
  deleteCdm(idList: string[]): void;
  updateDeleteCdmList(value: string[]): void;

  addRuleSetList(value: RuleSetRecord): void;
  updateRuleSetInList(key: number, value: RuleSetRecord): void;
  deleteRuleSets(idList: string[]): void;
  updateDeleteRuleSetList(value: string[]): void;

  updateAttachmentList(value: AttachmentItem[]): void;
  updateDeleteAttachmentRequestList(value: DeleteAttachmentRequest[]): void;
}

export interface IDataOwnerRequestContext {
  dataOwnerRequestDetails: IDataOwnerRequestDetails;
  dataOwnerRequestsList?: DataOwnerRequestRecord[];
}

export const DataOwnerRequestContext: Context<IDataOwnerRequestContext> =
  React.createContext<IDataOwnerRequestContext>({
    dataOwnerRequestDetails: {
      dataOwnerId: '',
      cdms: [],
      ruleSets: [],
      nonProdApprovedCdms: [],
      prodApprovedCdms: [],
      cdmDeletionList: [],
      ruleSetDeletionList: [],
      savedCdmIdList: [],
      savedRuleSetIdList: [],
      attachmentList: [],
      deleteAttachmentRequestList: [],
      addUpdateRequest: () => {},
      addCdmList: () => {},
      updateCdmList: () => {},
      deleteCdm: () => {},
      updateDeleteCdmList: () => {},
      addRuleSetList: () => {},
      updateRuleSetInList: () => {},
      deleteRuleSets: () => {},
      updateDeleteRuleSetList: () => {},
      updateAttachmentList: () => {},
      updateDeleteAttachmentRequestList: () => {},
    },
    dataOwnerRequestsList: [],
  });